import ProjectsDetail from "../../../components/Client/dashboardComponents/ProjectsDetail";
import ProjectInformations from "../../../components/Client/projectsComponents/ProjectInformations";
import ProjectSpace from "../../../components/Client/projectsComponents/ProjectSpace";
import { ProjectsRedirect } from "../../../components/Client/projectsComponents/ProjectsRedirect";
import AddProject from "../../../components/composPageAccueil/AddProject";
import AddForm from "../../../components/Worker/AddForm";
import { MesTemplates } from "../../../components/Worker/MesTemplates";
import ClientPage from "../../../layouts/ClientLayout/ClientPage";
import DashboardClientPage from "../../../pages/Client/DashboardClientPage";
import HistoriquePayment from "../../../pages/Client/HistoriquePayment";
import HistoriqueProject from "../../../pages/Client/HistoriqueProject";
import LivrablesPage from "../../../pages/Client/LivrablesPage";
import ParameterClientPage from "../../../pages/Client/ParameterClientPage";
import ProjectClientPage from "../../../pages/Client/ProjectClientPage";
import VoirLivrable from "../../../pages/Client/VoirLivrable";
import RequiredRole from "../../../roles/RequiredRole";
import { ADD_FORM, AJOUT_PROJET_CLIENT, CLIENT_DASHBOARDS, CLIENT_DASHBOARDS_DASHBOARD, DASHBOARD, DETAIL_PROJECT_DASHBOARD, DOCUMENT_PROJECT_DASHBOARD, DONNEES_FINANCIERES, LANDING_PAGE, LIVRABLE, LIVRAISONSDETAIL, MES_TEMPLATES, PARAMETER, PAYMENT, PROJECT_DETAIL_ID, PROJECTID, PROJECTS, TACHES, TELECHARGER_TEMPLATES, WORKER_PAGE } from "../navigationPaths";
// import LivraisonsPage from "../../../pages/Client/LivraisonsPage";

export const privateRoutes = [
  {
    path: CLIENT_DASHBOARDS,
    element: <ClientPage />,
    children: [
      {
        path: "",
        element: <DashboardClientPage />,
      },
      {
        path: CLIENT_DASHBOARDS_DASHBOARD,
        element: <DashboardClientPage />,
      },
      {
        path: AJOUT_PROJET_CLIENT,
        element: (
          <RequiredRole roles={["client"]}>
            <AddProject />
          </RequiredRole>
        ),
      },
      {
        path: PROJECT_DETAIL_ID,
        element: <ProjectsDetail />,
        children: [
          {
            path: `${DETAIL_PROJECT_DASHBOARD}/:id`,
            element: <LivrablesPage />,
          },
          {
            path: DOCUMENT_PROJECT_DASHBOARD,
            element: "Documents",
          },
          {
            path: DONNEES_FINANCIERES,
            element: "Données financières",
          },
        ],
      },
      {
        path: PROJECTS,
        element: <ProjectClientPage />,
        children: [
          {
            path: "",
            element: <ProjectsRedirect />,
          },
          {
            path: `:slug`,
            element: <ProjectSpace />,
          },
          {
            path: `:slug/infos`,
            element: <ProjectInformations />
          }
        ],
      },
      {
        path: PARAMETER,
        element: <ParameterClientPage />,
      },
      {
        path: LIVRABLE,
        element: <VoirLivrable />,
      },
      {
        path: `${LIVRABLE}/:id`,
        element: <LivrablesPage />,
      },
      {
        path: TACHES,
        element: <HistoriqueProject />,
      },
      {
        path: PAYMENT,
        element: <HistoriquePayment />,
      },
      {
        path: MES_TEMPLATES,
        element: <MesTemplates />,
      },
      {
        path: ADD_FORM,
        element: <AddForm />,
      },
    ],
  },
];